import { createTheme } from '@mui/material';
import { device } from './devices';

const theme = createTheme({
  palette: {
    text: {
      secondary: '#333',
    },
    primary: {
      light: '#71CE9D',
      main: '#0F8345',
      dark: '#084524',
    },
    secondary: {
      light: '#AFE3C7',
      main: '#FFF',
      dark: '#CCCCCC',
    },
    light: {
      main: '#F4F4F4',
    },
    transparent: {
      main: 'transparent',
    },
    error: {
      main: '#E04A4A',
    },
  },
  typography: {
    fontFamily: ['BayWaSans'].join(','),
    h1: {
      fontSize: '72px',
      [device.small]: {
        fontSize: '40px',
      },
    },
    h2: {
      fontSize: '40px',
    },
    h3: {
      fontSize: '24px',
    },
    h4: {
      fontSize: '20px',
    },
    h5: {
      fontSize: '18px',
      letterSpacing: '0.36px',
    },
    h6: {
      fontSize: '16px',
      [device.small]: {
        fontSize: '13px',
      },
    },
    subtitle1: {
      fontSize: '14px',
    },
    subtitle2: {
      fontSize: '12px',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1000,
      lg: 1200,
      xl: 1400,
    },
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'white',
          fontWeight: 600,
          '&.Mui-focused': {
            color: '#71CE9D !important',
            top: '12px !important',
            [device.small]: {
              fontSize: '6px !important',
            },
          },
        },
      },
    },
  },
});

export default theme;

declare module '@mui/material/styles' {
  interface Palette {
    light: Palette['primary'];
    transparent: Palette['primary'];
    error: Palette['primary'];
  }

  interface PaletteOptions {
    light?: PaletteOptions['primary'];
    transparent?: PaletteOptions['primary'];
    error?: PaletteOptions['primary'];
  }
}
